import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

interface ShopProduct {
  _id: string;
  shop_id: string;
  product_id: string;
  price: number;
  product_subcategory?: string;
  created_at: string;
  updated_at: string;
}

interface CreateShopProductRequest {
  shop_id: string;
  product_id: string;
  price: number;
  product_subcategory?: string;
}

interface UpdateShopProductRequest {
  price?: number;
  product_subcategory?: string;
}

export const shopProductsApi = createApi({
  reducerPath: 'shopProductsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ShopProducts'],
  endpoints: (builder) => ({
    getShopProducts: builder.query<ShopProduct[], string | void>({
      query: (shop_id) => ({
        url: shop_id ? `/shop-products?shop_id=${shop_id}` : '/shop-products',
        method: 'GET',
      }),
      providesTags: ['ShopProducts'],
    }),
    getShopProduct: builder.query<ShopProduct, string>({
      query: (id) => `/shop-products/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'ShopProducts', id }],
    }),
    createShopProduct: builder.mutation<ShopProduct, CreateShopProductRequest>({
      query: (data) => ({
        url: '/shop-products',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ShopProducts'],
    }),
    updateShopProduct: builder.mutation<ShopProduct, { id: string; data: UpdateShopProductRequest }>({
      query: ({ id, data }) => ({
        url: `/shop-products/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'ShopProducts',
        { type: 'ShopProducts', id },
      ],
    }),
    deleteShopProduct: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/shop-products/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ShopProducts'],
    }),
  }),
});

export const {
  useGetShopProductsQuery,
  useGetShopProductQuery,
  useCreateShopProductMutation,
  useUpdateShopProductMutation,
  useDeleteShopProductMutation,
} = shopProductsApi;